import { theme } from 'antd';

const FONT_STACK = '"Untitled Sans", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

const lightTokens = {
  colorPrimary: '#111827',
  colorError: '#ef4444',
  colorWarning: '#fbbf24',
  colorSuccess: '#047857',
  colorInfo: '#0ea5e9',
  colorBgLayout: '#f9fafb',
  colorBgContainer: '#ffffff',
  colorBgElevated: '#ffffff',
  colorText: '#3D3D3D',
  colorTextHeading: '#111827',
  colorTextSecondary: '#4b5563',
  colorBorder: '#d1d5db',
  colorBorderSecondary: '#e5e7eb',
  colorTextLightSolid: '#ffffff',
  fontFamily: FONT_STACK,
  borderRadius: 4,
  fontSize: 14,
};

const darkTokens = {
  colorPrimary: '#ffffff',
  colorError: '#ef4444',
  colorWarning: '#fbbf24',
  colorSuccess: '#047857',
  colorInfo: '#ffffff',
  colorBgLayout: '#000000',
  colorBgContainer: '#0a0a0a',
  colorBgElevated: '#141414',
  colorText: '#f9fafb',
  colorTextHeading: '#ffffff',
  colorTextSecondary: '#9ca3af',
  colorBorder: '#262626',
  colorBorderSecondary: '#1a1a1a',
  colorTextLightSolid: '#111827',
  fontFamily: FONT_STACK,
  borderRadius: 4,
  fontSize: 14,
};

const buttonComponentTokens = {
  borderRadius: 4,
  borderRadiusLG: 4,
  borderRadiusSM: 4,
  controlHeight: 36,
  controlHeightLG: 44,
  controlHeightSM: 28,
  paddingInline: 20,
  paddingInlineLG: 28,
  paddingInlineSM: 12,
  fontWeight: 400,
  defaultShadow: 'none',
  primaryShadow: 'none',
  dangerShadow: 'none',
};

export const lightTheme = {
  algorithm: theme.defaultAlgorithm,
  token: lightTokens,
  components: {
    Input: {
      hoverBg: '#ffffff',
      activeBg: '#ffffff',
      hoverBorderColor: '#111827',
      activeBorderColor: '#111827',
      activeShadow: '0 0 0 2px rgba(17, 24, 39, 0.1)',
    },
    Button: {
      ...buttonComponentTokens,
      colorPrimaryHover: '#000000',
      colorPrimaryActive: '#000000',
      defaultBorderColor: '#111827',
      defaultColor: '#111827',
      defaultHoverBg: '#111827',
      defaultHoverColor: '#ffffff',
      defaultHoverBorderColor: '#111827',
      defaultActiveBg: '#111827',
      defaultActiveColor: '#ffffff',
      defaultActiveBorderColor: '#111827',
    },
  },
};

export const darkTheme = {
  algorithm: theme.darkAlgorithm,
  token: darkTokens,
  components: {
    Input: {
      hoverBg: 'transparent',
      activeBg: 'transparent',
    },
    Button: {
      ...buttonComponentTokens,
      colorPrimaryHover: '#e5e7eb',
      colorPrimaryActive: '#d1d5db',
      defaultBorderColor: '#ffffff',
      defaultColor: '#ffffff',
      defaultHoverBg: '#ffffff',
      defaultHoverColor: '#111827',
      defaultHoverBorderColor: '#ffffff',
      defaultActiveBg: '#ffffff',
      defaultActiveColor: '#111827',
      defaultActiveBorderColor: '#ffffff',
    },
  },
};
